<div class="container-fluid">
    <div class="col-lg-2">
        <a routerLink="/addMaterial">
            <button type="button" class="btn btn-outline-dark">Add Material</button>
        </a>
    </div>
  
    <div class="row pt-3">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="card">
                    <div class="card-header bg-primary text-center text-white">
                     Material allocated on  Subcategories of {{ selectedSubcategory }}
                    </div>
                    <div class="card-body">
                        <table class="table table-bordered">
                            <thead>
                                <tr class="bg">
                                    <th>Code</th>
                                    <th>Description</th>
                                    <th>Input</th>
                                    <th>Output</th>
                                    <th>Balance</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                        <!-- Inside the table body -->
                       <!-- Inside the table body -->
<tr *ngFor="let material of materials">
    <!-- Display code prefix for each category -->
    <td>{{ codePrefix }}</td>
    <!-- Display the current category -->
    <td>{{ material.material }}</td>

    <td>{{ calculateTotalInput(material.material) }}</td>
    <td>{{ calculateTotalOutput(material.material) }}</td>
    <td>{{ calculateTotalBalance(material.material) }}</td>
    <td>
        <button class="button-7" role="button" (click)="viewDetails(material)">View Details</button>
        <button class="button-7" role="button" (click)="onNextButtonClick(material)">Next</button>
    </td>
</tr>


                          </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  
  
    